import { render, staticRenderFns } from "./AircraftDetailList.vue?vue&type=template&id=2bc8247d&"
import script from "./AircraftDetailList.vue?vue&type=script&lang=js&"
export * from "./AircraftDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports